module.exports = __webpack_public_path__ + "static/media/lob-dining-hall.56c12243.png";